export const initialStateProfile = {
  imgUrl: "",
  firstName: "",
  lastName: "",
  email: "",
  isEnable2FA: false,
  twoFAType: "",
  recoveryEmail: "",
};
